export default "__VITE_ASSET__cfe1f5e1__"